import './OrderNextTest.css';

const OrderNextTest = () => {
  return (
    <>
      <h1 className="coach-title">Coming soon</h1>
    </>
  );
};

export default OrderNextTest;
